type Translator = {
  instant: (key: string) => string;
};

const translateInline = (text: string, translate: Translator): string => {
  return text.replace(/\$\{(.*?)\}/g, function (_: string, contents: string) {
    return translate.instant(contents);
  });
};

export default translateInline;
